// extracted by mini-css-extract-plugin
module.exports = {"item":"a10a3f92e9--item--qJhdR","group":"a10a3f92e9--group--K5ZqN","right":"a10a3f92e9--right--_9uBM","header":"a10a3f92e9--header--RGZa5"};